import { useQuery } from "@tanstack/react-query"
import { client } from "@/api"

export interface AdminDiagram {
  public_id: string
  name: string
  description: string | null
  offensive_formation_id: string | null
  defensive_formation_id: string | null
  play_type: string | null
  version: number
  created_at: string
  updated_at: string
  creator_public_id: string | null
  creator_name: string | null
  creator_email: string | null
  team_public_id: string | null
  team_name: string | null
}

interface AdminDiagramsResponse {
  diagrams: AdminDiagram[]
}

interface AdminDiagramsQueryParams {
  limit?: number
  offset?: number
  search?: string
  creator?: string
}

export function useAdminDiagrams({
  limit = 50,
  offset = 0,
  search,
  creator,
}: AdminDiagramsQueryParams = {}) {
  return useQuery<AdminDiagramsResponse>({
    queryKey: ["admin", "diagrams", { limit, offset, search, creator }],
    queryFn: async () => {
      const response = await client.admin.diagrams.$get({
        query: {
          limit: limit.toString(),
          offset: offset.toString(),
          ...(search ? { search } : {}),
          ...(creator ? { creator } : {}),
        },
      })

      if (!response.ok) {
        throw new Error(`Failed to fetch diagrams: ${response.status}`)
      }

      return response.json()
    },
  })
}
